import React, { useState } from "react";
import { motion } from "framer-motion";
import Navbar from "../components/Navbar"; // Import Navbar component
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";

const Contact = () => {
  const [showPhone, setShowPhone] = useState(false);

  const handlePhoneClick = () => {
    setShowPhone(!showPhone);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    alert("Message sent successfully!"); // Replace with email sending logic
  };

  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className="bg-gray-100 min-h-screen pt-28 relative"
    >
      {/* Navbar */}
      <Navbar />

      {/* Hero Section */}
      <div className="relative bg-blue-100 py-16 px-6 text-center">
        <motion.div
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="max-w-6xl mx-auto"
        >
          <h1 className="text-4xl font-bold text-blue-900 mb-6">Contact Us</h1>
          <p className="text-lg text-gray-700 leading-relaxed">
            We’re Happy to Discuss Your Needs and Answer Any Questions
          </p>
        </motion.div>
      </div>

      {/* Contact Information Section */}
      <motion.div
        className="container mx-auto px-6 md:px-16 py-12"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.5 }}
      >
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div className="bg-white rounded-lg shadow-lg p-6 text-center">
            <h3 className="text-2xl font-bold text-blue-900 mb-4">Location</h3>
            <p className="text-gray-700">Tena Estate P.O Box 3721-00200 Nairobi, Kenya</p>
          </div>
          <div className="bg-white rounded-lg shadow-lg p-6 text-center">
            <h3 className="text-2xl font-bold text-blue-900 mb-4">Email</h3>
            <p className="text-gray-700">info@joygardenschool.co.ke</p>
            <p className="text-gray-700">admin@joygardenschool.co.ke</p>
          </div>
          <div className="bg-white rounded-lg shadow-lg p-6 text-center">
            <h3 className="text-2xl font-bold text-blue-900 mb-4">Toll Numbers</h3>
            <p className="text-gray-700">+254 707 800 945</p>
            <p className="text-gray-700">+254 726 938 713</p>
          </div>
        </div>
      </motion.div>

      {/* Contact Form Section */}
      <div className="bg-gray-200 py-12">
        <div className="container mx-auto px-6 md:px-16">
          <h2 className="text-3xl font-bold text-blue-900 mb-8 text-center">Want to Talk? Let’s Do It!</h2>
          <form
            className="bg-white rounded-lg shadow-lg p-8 space-y-6"
            onSubmit={handleFormSubmit}
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <input
                type="text"
                placeholder="Your Name"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
              <input
                type="email"
                placeholder="Your Email"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <input
                type="tel"
                placeholder="Your Phone"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
              <input
                type="text"
                placeholder="Subject"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>
            <textarea
              placeholder="Type Message Here..."
              rows="5"
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            ></textarea>
            <div className="text-center">
              <button
                type="submit"
                className="bg-blue-900 text-white px-8 py-3 rounded-full font-medium text-lg shadow-lg hover:bg-blue-700 transition"
              >
                Send Message
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Floating Icons */}
      <div className="fixed bottom-8 right-8 flex flex-col space-y-4">
        <motion.a
          href="https://wa.me/254707800945"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-green-500 p-4 rounded-full shadow-lg hover:bg-green-600 transition flex items-center justify-center"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          <FaWhatsapp className="text-white text-3xl" />
        </motion.a>

        <motion.div
          onClick={handlePhoneClick}
          className="bg-blue-500 p-4 rounded-full shadow-lg hover:bg-blue-600 transition flex items-center justify-center cursor-pointer"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          <FaPhoneAlt className="text-white text-3xl" />
        </motion.div>

        {showPhone && (
          <div className="absolute bottom-24 right-8 bg-white p-4 rounded-lg shadow-lg border border-gray-300">
            <p className="text-blue-900 font-bold">+254 707 800 945</p>
          </div>
        )}
      </div>
    </motion.section>
  );
};

export default Contact;
